
import Shield from "../../../assets/outline/Shield.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShieldIcon({ className, dataTestid = "ShieldIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Shield data-testid={dataTestid} className={classes} {...rest} />
  );
}
